import { render, staticRenderFns } from "./DateCarousel.vue?vue&type=template&id=051d057a"
import script from "./DateCarousel.vue?vue&type=script&lang=ts"
export * from "./DateCarousel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports